import { KPI } from "./ui.jsx";
import { SUMMARY_CARDS } from "../constants.js";

/* Read-only KPI strip derived from the queue + dry-run job count. */
export default function SummaryCards({ rows, dryRunJobs }) {
  const countStatus = (s) => rows.filter((r) => r.status === s).length;
  const values = {
    total: rows.length,
    missing_photo: countStatus("missing_photo"),
    ready_for_preview: countStatus("ready_for_preview"),
    pending_approval: countStatus("pending_approval"),
    approved: countStatus("approved"),
    duplicate: rows.filter((r) => r.status === "duplicate_warning" || r.status === "duplicate_blocked").length,
    dry_run_jobs: dryRunJobs,
  };
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 12, marginBottom: 20 }}>
      {SUMMARY_CARDS.map((c) => (
        <KPI key={c.key} label={c.label} value={values[c.key] ?? 0} />
      ))}
    </div>
  );
}
